<template>
  <div class="table-filters">
    <template v-for="(item, name) in panelProps.filters">
      <div
        v-if="item.show"
        :key="name"
        class="table-filters__item">
        <div class="table-filters__item-label">
          {{ item.label }}
        </div>
        <el-select v-model="localModelValue[item.criterion]">
          <el-option
            v-for="option in item.options"
            :key="option.label"
            :value="option.value"
            :label="option.label"/>
        </el-select>
      </div>
    </template>
  </div>
</template>

<script>
import {ElSelect, ElOption} from 'element-plus'

export default {
  name: "TableFilters",
  components: {
    ElSelect,
    ElOption,
  },
  props: {
    panelProps: Object,
    modelValue: Object,
  },
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue)
      },
    }
  }
}
</script>

<style scoped>

</style>
